'use client';
import React from 'react';

const stats = [
  { value: '50+', label: 'Lending Partners', icon: '🤝' },
  { value: '₹10K Cr+', label: 'Loans Disbursed', icon: '💰' },
  { value: '25 Lakh+', label: 'Happy Customers', icon: '😊' },
  { value: '9.98%', label: 'Lowest Rate p.a.', icon: '📉' },
];

export default function StatsSection() {
  return (
    <section className="py-8 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats?.map((stat) => (
            <div key={stat?.label} className="flex items-center gap-3 p-4 rounded-xl bg-orange-50 border border-orange-100">
              <div className="text-3xl">{stat?.icon}</div>
              <div>
                <div className="text-xl font-bold text-primary">{stat?.value}</div>
                <div className="text-xs text-gray-500">{stat?.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
